import "./footer.scss";

function footer() {
  return (
    <>
      <div className="footer-container">
        <div className="footer">
          @Copyright 2024. Designed and Developed by <a href="https://sohamandaliya.netlify.app" target="_SM">Soham Mandaliya</a>
        </div>
      </div>
    </>
  );
}

export default footer;
